module.exports = __webpack_public_path__ + "img/roundtrip-banner.3f02f0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/roundtrip-banner.png
// module id = 1097
// module chunks = 0